import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import enUS1 from './locale/en-US';
import zhCN1 from './locale/zh-CN';
import { setLocale, Di18nProvider } from 'di18n-react';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import LoginLayout from '@/pages/nms/login/LoginLayout';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import { getServerConfig } from '@/services/analysis';
import './index.css';
window.React = React;
import './virtual:windi.css';
// 创建 store 时，传入参数
const store = createStore(rootReducer, composeWithDevTools());
function Index() {
  const [lang, setLang] = useStorage('arco-lang', navigator.language == 'zh-CN' ? 'zh-CN' : 'en-US');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
    return zhCN;
  }
  function fetchUserInfo() {
    axios.get('/api/user/userInfo').then(res => {
      store.dispatch({
        type: 'update-userInfo',
        payload: {
          userInfo: res.data
        }
      });
    });
  }
  useEffect(() => {
    if (checkLogin()) {
      getServerConfig().then(res => {
        store.dispatch({
          type: 'update-analysisInfo',
          payload: {
            analysisInfo: {
              linePointCount: res?.splitPoint ?? 30,
              maxTime: res?.logExistsDay ?? 7
            }
          }
        });
      });
      // fetchUserInfo();
    } else if (!window.location.pathname.startsWith('/nms/login')) {
      window.location.pathname = '/nms/login';
    }
    //获取数据分析的一些配置信息
  }, []);
  useEffect(() => {
    if (!localStorage.getItem('arco-lang')) {
      localStorage.setItem('arco-lang', navigator.language == 'zh-CN' ? 'zh-CN' : 'en-US');
      setLocale(navigator.language == 'zh-CN' ? 'zh-CN' : 'en-US', {
        cookieLocaleKey: 'lang'
      });
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
    document.body.style.setProperty(`--arcoblue-6`, '20, 92, 211');
  }, [theme]);
  useEffect(() => {
    setLang(localStorage.getItem('arco-lang'));
  }, [localStorage.getItem('arco-lang')]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Form: {
        labelCol: {
          flex: lang === 'zh-CN' ? '120px' : '160px'
        },
        wrapperCol: {
          flex: 1
        }
      },
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: true,
        // stripe: true,
        size: 'small',
        showSorterTooltip: false,
        placeholder: '-',
        scroll: {
          x: 'max-content'
        }
      },
      Button: {
        // 修改默认规则
        type: 'primary',
        loadingFixedWidth: true,
        style: {
          borderRadius: '4px'
        }
      },
      Input: {
        autoComplete: 'off'
      },
      Pagination: {
        sizeCanChange: true,
        showTotal: true,
        pageSizeChangeResetCurrent: true
      },
      Modal: {
        maskClosable: false,
        cancelButtonProps: {
          type: 'default'
        }
      },
      Popconfirm: {
        cancelButtonProps: {
          type: 'secondary'
        }
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(Di18nProvider, {
    locales: {
      'zh-CN': zhCN1,
      'en-US': enUS1
    }
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/nms/login",
    component: LoginLayout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  })))))));
}
ReactDOM.render(/*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));